// extracted by mini-css-extract-plugin
module.exports = {"loginError":"Error_loginError__P4-Ai"};